/* ObiHub OS — tasarım token sözleşmesi (tek doğruluk kaynağı).  CSS değişkenleri `obihub-os.css` içinde AYNI değerlerle tanımlıdır (test eşliği zorunlu).
   Marka rengi mevcut logo tealidir (#1487A3); düğme dolguları ve metin vurguları AA kontrastı için `brandStrong`/`brandDeep` kullanır. */
const tokens = {
  color: {
    brand: "#1487A3",            // logo teali: yalnız vurgu/dekor (beyaz üstünde metin için YETERSİZ kontrast: 4.18)
    brandStrong: "#0E7490",      // birincil dolgu (beyaz metin 5.36:1)
    brandDeep: "#0B6178",        // birincil hover/aktif (7.01:1)
    text: "#0B1223",
    textMuted: "#4A5568",
    canvas: "#F4F6F8",
    surface: "#FFFFFF",
    surfaceRaised: "#FFFFFF",
    border: "#D5DBE3",
    borderStrong: "#8A94A6",     // form alanı sınırı (≥3:1 hedefi)
    focus: "#0E7490",
    danger: "#B42318",
    warning: "#B54708",
    success: "#067647",
    info: "#175CD3",
    review: "#6941C6",
    blocked: "#475467",
  },
  tone: {                         // rozet/durum çiftleri: metin ve zemin ≥ 4.5:1
    neutral: { fg: "#344054", bg: "#F2F4F7", border: "#D0D5DD" },
    info: { fg: "#175CD3", bg: "#EFF8FF", border: "#B2DDFF" },
    success: { fg: "#067647", bg: "#ECFDF3", border: "#ABEFC6" },
    warning: { fg: "#B54708", bg: "#FFFAEB", border: "#FEDF89" },
    danger: { fg: "#B42318", bg: "#FEF3F2", border: "#FECDCA" },
    review: { fg: "#6941C6", bg: "#F4F3FF", border: "#D9D6FE" },
    blocked: { fg: "#475467", bg: "#F2F4F7", border: "#D0D5DD" },
  },
  radius: { chip: "6px", control: "8px", surface: "12px", overlay: "16px" },   // hap (pill) YOK: düğmeler 8px
  space: { 0: "0px", 1: "4px", 2: "8px", 3: "12px", 4: "16px", 5: "20px", 6: "24px", 8: "32px", 10: "40px", 12: "48px" },
  size: {
    control: { sm: "32px", md: "36px", lg: "44px" },     // lg = dokunmatik hedef (≥44px)
    icon: { sm: "16px", md: "20px", lg: "24px" },
  },
  font: {
    family: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
    size: { xs: "12px", sm: "13px", md: "14px", lg: "16px", xl: "20px", xxl: "24px", display: "32px" },
    weight: { regular: "400", medium: "500", semibold: "600", bold: "700" },
    lineHeight: { tight: "1.25", normal: "1.5" },
  },
  z: { base: 0, sticky: 10, tabs: 20, dock: 30, popover: 40, drawer: 50, modal: 60, toast: 70 },   // eski uygulamanın ≥200 katmanlarının ALTINDA
  motion: { fast: "120ms", base: "180ms", slow: "240ms", easing: "cubic-bezier(0.2, 0, 0, 1)" },
  shadow: {
    none: "none",
    raised: "0 1px 2px rgba(11, 18, 35, 0.06), 0 1px 3px rgba(11, 18, 35, 0.08)",
    overlay: "0 8px 24px rgba(11, 18, 35, 0.16)",
  },
  density: { compact: "32px", comfortable: "40px", spacious: "48px" },   // tablo satır yüksekliği
};

function cssVarName(path) {
  return `--os-${String(path).replace(/\./g, "-")}`;
}

function flattenTokens(node = tokens, prefix = "") {
  const out = [];
  for (const [key, value] of Object.entries(node)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value !== null && typeof value === "object") out.push(...flattenTokens(value, path));
    else out.push([path, String(value)]);
  }
  return out;
}

export { tokens, cssVarName, flattenTokens };
